<template>
  <!-- TODO CheckoutPage template -->
  <div>
      <cabinet-header></cabinet-header>
      <section class="new_order">
        <order-info @changePayType="pay_type = $event"></order-info>
        <order-products :pay_type="pay_type"></order-products>
        <div class="container has_table">
          <add-order-item></add-order-item>
        </div>
      </section>
  </div>
</template>

<script>
import OrderInfo from '../../components/modules/Checkout/OrderInfo'
import CabinetHeader from '../../components/modules/Cabinet/CabinetHeader'
import OrderProducts from '../../components/modules/Checkout/OrderProducts'
import AddOrderItem from '../../components/modules/Checkout/AddOrderItem'

export default {
  name: 'CheckoutPage',
  data () {
    return {
      pay_type: 1
    }
  },
  components: {
    OrderInfo,
    CabinetHeader,
    OrderProducts,
    AddOrderItem
  }
}
</script>

<style scoped>

</style>
